module.exports = __webpack_public_path__ + "img/slider-foto7.e8d61e19.png";